@if (customerIsLogged && currentCustomer?.userData) {
<div class="customer-info-container" #customerInfo (click)="toggleCustomerInfo()">
  <div class="user-icon">
    <ng-casto-button [faIcon]="faUser" class="action"></ng-casto-button>
  </div>
  <div class="info">
    <span class="name sentry-mask">
      {{ customerFullName }}
    </span>
    <span class="id">
      {{ currentCustomer.userData?.kfId }}
    </span>
  </div>
  <div class="fidelity-card">
    @if (isLoading) {
    <ng-casto-loader></ng-casto-loader>
    } @else {
    @if (fidelityEnabled()) {
    @switch (true) {
    @case (currentCustomer.fidelity?.cardIsPaidButNotActiveYet) {
    <img src="assets/img/c-casto-waiting-activation.png" />
    }
    @case (currentCustomer.fidelity?.typeCard === FidelityCardTypeEnum.GRATUITE) {
    <img src="assets/img/ccasto.png" />
    }
    @case (currentCustomer.fidelity?.typeCard === FidelityCardTypeEnum.PREMIUM) {
    <img src="assets/img/ccastomax.png" />
    }
    @case (currentCustomer.fidelity?.typeCard === FidelityCardTypeEnum.PREMIUMWAITING) {
    <img src="assets/img/c-casto-waiting-payment.png" />
    }
    @default {
    <img src="assets/img/c-casto-no-card.png" />
    }
    }
    }
    }
  </div>
  <div class="open-icon">
    <fa-icon [icon]="faChevronRight"></fa-icon>
  </div>
</div>
}

<p-sidebar styleClass="customer-info-sidebar" [(visible)]="customerInfoVisible" position="right" baseZIndex="3000"
  appendTo="body" (onHide)="onClose()">
  <ng-template pTemplate="header">
    @if (appointmentDate) {
    <span class="casto-title decorator" [innerHTML]="
        'customer-info.appointment.header-title'
          | translate
            : {
                date: displayedAppointmentDate,
              }
      "></span>
    } @else {
    <span class="casto-title decorator" [innerHTML]="
        'customer-info.title'
          | translate
            : {
                name: customerFullName,
              }
      "></span>
    }

  </ng-template>
  <p-tabMenu [model]="tabMenuItems" [(activeItem)]="activeTabMenuItem">
    <ng-template pTemplate="item" let-item>
      <span class="p-menuitem-link" [innerHTML]="item.label | translate"></span>
    </ng-template>
  </p-tabMenu>
  <div class="content">
    <ng-container #customerInfoContainer></ng-container>
  </div>
</p-sidebar>
